import { useNavigate } from "react-router-dom";

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      <div className="text-center text-danger">
        {/* Icon */}
        <div style={{ fontSize: "5rem" }} role="img" aria-label="lock">
          🔒
        </div>
        <h1 className="display-1">401</h1>
        <h2>Unauthorized Access</h2>
        <p className="mt-3 text-secondary">
          Sorry, you do not have permission to view this page.<br />
          Please login with the appropriate credentials or return to the homepage.
        </p>
        <button
          className="btn btn-outline-primary mt-3"
          onClick={() => navigate("/")}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
